import styled from 'styled-components';

export const Image = styled.img`
  aspect-ratio: ${({ $aspectRatio: [x, y] }) => `${x} / ${y}`};
  height: 32px;
  object-fit: contain;
`;
